import { USER_URL } from "../constant/api";

// get sellers balance
export const SellersBalanceFetchApi = async () => {
  try {
    const response = await USER_URL.get("/accounts/admin/sellers/payout/");
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("Failed to fetch sellers balance", error);
    throw error;
  }
};

// post seller payout
export const SellerPayoutPostApi = async (payoutData) => {
  try {
    const response = await USER_URL.post("/accounts/admin/seller-payout/", payoutData);
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("Failed to process seller payout", error);
    throw error;
  }
};

// post seller settlement
export const SellerSettlementPostApi = async (settlementData) => {
  try {
    const response = await USER_URL.post("/accounts/admin/seller/cod-service-fee/settlement/", settlementData);
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("Failed to process seller settlement", error);
    throw error;
  }
};


/* =====================================================
   ADMIN REVENUE
   ===================================================== */

export const RevenueSummaryFetchApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/admin/revenue/summary/"
    );
    return res.data;
  } catch (error) {
    console.error("Failed to fetch revenue summary", error);
    throw error;
  }
};

export const PlatformIncomeFetchApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/admin/revenue/platform-income/"
    );
    return res.data;
  } catch (error) {
    console.error("Failed to fetch platform income", error);
    throw error;
  }
};

export const SubadminPerformanceFetchApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/admin/revenue/subadmin-performance/"
    );
    return res.data;
  } catch (error) {
    console.error("Failed to fetch subadmin performance", error);
    throw error;
  }
};

/* =====================================================
   SUBADMIN PAYOUT
   ===================================================== */

export const getSubadminPayouts = () => {
  return USER_URL.get(
    "/accounts/admin/subadmins/payout/"
  );
};


export const getSubadminPayoutDetails = (subadminId) => {
  return USER_URL.get(
    `/accounts/admin/subadmins/payout/${subadminId}/`
  );
};

// POST: Pay Subadmin
export const paySubadminCommission = (payload) => {
  return USER_URL.post(
    "/accounts/admin/subadmin-payout/",
    payload
  );
};



//ordercommission

export const getOrderCommissionReport = async ({
  from_date,
  to_date,
  subadmin,
  payment,
  status,
}) => {
  const params = {};

  if (from_date) params.from_date = from_date;
  if (to_date) params.to_date = to_date;

  // ✅ Subadmin → user_id only
  if (subadmin && subadmin !== "ALL") {
    params.subadmin = subadmin;
  }

  // ✅ Payment filter
  if (payment && payment !== "ALL") {
    params.payment = payment;

    // 🔴 Derive status implicitly
    if (payment === "COD") {
      params.status = "PENDING";
    }

    if (payment === "ONLINE PAYMENT") {
      params.status = "COLLECTED";
    }
  }

  // ✅ Only allow manual status filter if payment = ALL
  if (
    payment === "ALL" &&
    status &&
    status !== "ALL"
  ) {
    params.status = status;
  }

  const { data } = await USER_URL.get(
    "/accounts/admin/revenue/orders/",
    { params }
  );

  return data;
};


/* =====================================================
   REVENUE PROMOTION
   ===================================================== */

export const RevenuePromotionFetchApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/admin/revenue/promotion/"
    );
    console.log("PROMOTION REVENUE RESPONSE", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch promotion revenue", error);
    throw error;
  }
};


/* =====================================================
   SUBADMIN REVENUE
   ===================================================== */

// GET: Subadmin Balance
export const getSubadminBalanceApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/subadmin/balance/"
    );
    console.log("Subadmin balance", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch subadmin balance", error);
    throw error;
  }
};

// GET: Subadmin Transactions
export const getSubadminTransactionsApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/subadmin/transactions/"
    );
    console.log("Subadmin transactions", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch subadmin transactions", error);
    throw error;
  }
};

// GET: Subadmin Sellers
export const getSubadminSellersApi = async () => {
  try {
    const res = await USER_URL.get(
      "/accounts/subadmin/sellers/"
    );
    console.log("Subadmin sellers", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch subadmin sellers", error);
    throw error;
  }
};


/* =====================================================
   SELLER REVENUE 
   ===================================================== */


 // GET: seller balance
 
export const getSellerBalanceApi = async () => {
  try {
    const res = await USER_URL.get("/accounts/seller/balance/");
    console.log("Seller Balance:", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch seller balance", error);
    throw error;
  }
};


 // GET: seller transactions
 
export const getSellerTransactionsApi = async (page = 1, pageSize = 20) => {
  try {
    const res = await USER_URL.get("/accounts/seller/transactions/", {
      params: {
        page: page,
        page_size: pageSize,
      },
    });
    console.log("Seller Transactions:", res.data);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch seller transactions", error);
    throw error;
  }
};
